import { resultPathColors } from '../constants/game';
import { DEFAUL_MARKER_ICON, MARKER_PLACE_ICON_KDETOSAKRA } from '../constants/icons';
import gameModes from '../enums/modes';
import { mapLayers } from '../redux/reducers/game';

export const DEFAULT_MODE_ZOOM = 14;


export const mouseControlOptions = {
    scrollDelay: 5000,
    maxDriftSpeed: 20,
    driftSlowdown: 0.5,
    // idleDelay: 550,
};

export const markerOptions = {
    url: DEFAUL_MARKER_ICON,
    anchor: { left: 10, bottom: 1 },
};
export const markerPanoramaOptions = {
    url: MARKER_PLACE_ICON_KDETOSAKRA,
    anchor: { left: 10, bottom: 15 },
};

export const initCityMapInstance = (SMap, mapRefValue, latCenter, lonCenter, radius, city, mode) => {
    // not random mode
    let defaultModeZoom = DEFAULT_MODE_ZOOM - 1;
    const center = SMap.Coords.fromWGS84(lonCenter, latCenter);
    const mapInstance = new SMap(mapRefValue, center, 7);
    if (radius > 2 && radius <= 6 && radius <= 10) {
        if (city.cityRange) {
            defaultModeZoom -= city.cityRange > 1 ? city.cityRange - 1 : city.cityRange;
        }
    } else if (radius > 6 && radius <= 10) {
        if (city.cityRange) {
            defaultModeZoom -= city.cityRange;
        }
    }

    if (mode === gameModes.randomRegion) {
        defaultModeZoom = 8;
    }

    mapInstance.setCenterZoom(
        SMap.Coords.fromWGS84(city.coordinates.longitude, city.coordinates.latitude),
        defaultModeZoom,
        true,
    );
    return mapInstance;
};

const drawResultPathToLayer = (SMap, layerWithMarks, vectorLayer, point, pathColor, markerName) => {
    const pointPanorama = SMap.Coords.fromWGS84(point.pointPanorama.x, point.pointPanorama.y);
    const pointMap = SMap.Coords.fromWGS84(point.pointMap.x, point.pointMap.y);
    const pointsVectorArray = [pointPanorama, pointMap];

    const path = new SMap.Geometry(SMap.GEOMETRY_POLYLINE, null, pointsVectorArray, {
        color: pathColor,
        width: 3,
    });
    vectorLayer.addGeometry(path);

    // my guessed marker
    const marker = new SMap.Marker(
        SMap.Coords.fromWGS84(point.pointMap.x, point.pointMap.y),
        `Můj odhad ${markerName}`,
        markerOptions,
    );
    layerWithMarks.addMarker(marker);
    // panorama place marker
    const markerPanorama = new SMap.Marker(
        SMap.Coords.fromWGS84(point.pointPanorama.x, point.pointPanorama.y),
        `Panorama ${markerName}`,
        markerPanoramaOptions,
    );
    layerWithMarks.addMarker(markerPanorama);
};

export const drawAllResultsLayerToMap = (SMap, mapInstance, layerWithMarks, vectorLayer, guessedPoints) => {
    for (let i = 0; i < guessedPoints.length; i++) {
        const pointsObject = guessedPoints[i];
        // `Panorama ${i + 1}`
        if (pointsObject) {
            drawResultPathToLayer(SMap, layerWithMarks, vectorLayer, pointsObject, resultPathColors[i % resultPathColors.length], `round${i}`);
        }
    }
};

export const drawSingleRoundResultLayerToMap = (SMap, mapInstance, layerWithMarks, currentRoundGuessedPoint) => {
    const vectorLayer = new SMap.Layer.Geometry();
    mapInstance.addLayer(vectorLayer);
    vectorLayer.enable();
    drawResultPathToLayer(SMap, layerWithMarks, vectorLayer, currentRoundGuessedPoint, '#f00', 'round');
};

export const getMapInstanceByGameMode = (SMap, mode, city, radius, mapRefValue) => {
    if (
        (mode === gameModes.geolocation ||
            mode === gameModes.city ||
            mode === gameModes.custom ||
            mode === gameModes.randomRegion) &&
        city
    ) {
        return initCityMapInstance(
            SMap,
            mapRefValue,
            city.coordinates.latitude,
            city.coordinates.longitude,
            radius,
            city,
            mode,
        );
    }
    const center = SMap.Coords.fromWGS84(15.202828, 50.027429);
    return new SMap(mapRefValue, center, 7);
};

/**
 * OPTIMALIZACE: Lazy loading vrstev
 * - Pridava pouze aktivni vrstvu, druhou az pri prepnuti
 * - LayerSwitch se vytvari jen jednou per instance
 */
export const setupMapInstance = (SMap, mapInstance, mapLayer, isReused = false) => {
    // Pokud je instance znovupouzita, preskocime zakladni setup
    if (!isReused) {
        mapInstance.addDefaultControls();
        mapInstance.addControl(new SMap.Control.Sync());
        mapInstance.setZoomRange(7, 19);

        const mouse = new SMap.Control.Mouse(
            // eslint-disable-next-line no-bitwise
            SMap.MOUSE_PAN | SMap.MOUSE_WHEEL | SMap.MOUSE_ZOOM,
            mouseControlOptions,
        );
        mapInstance.addControl(mouse);
    }

    // LAZY LOADING: Pridame jen aktivni vrstvu (nepouzivame globalni cache - kazda instance ma sve)
    if (mapLayer === mapLayers.tourist) {
        mapInstance.addDefaultLayer(SMap.DEF_TURIST).enable();
    } else {
        mapInstance.addDefaultLayer(SMap.DEF_BASE).enable();
    }

    // Layer switch
    if (!isReused) {
        const layerSwitch = new SMap.Control.Layer({
            width: 65,
            items: 2,
            page: 2,
        });
        layerSwitch.addDefaultLayer(SMap.DEF_BASE);
        layerSwitch.addDefaultLayer(SMap.DEF_TURIST);
        mapInstance.addControl(layerSwitch, { left: '8px', top: '20px' });
    }
};


/**
 * OPTIMALIZACE: Pouze marker vrstva, bez POI a dataProvider
 * - POI vrstva a dataProvider nejsou pro hru potreba
 * - Kazdy dataProvider vytvari dalsi API requesty na server
 * - Pro hru staci jen vrstva s markery pro odhady
 *
 * @deprecated Pouzijte setupMarkerLayerOnly misto teto funkce
 */
export const setupLayerWithMarksAndDataProvider = (SMap, mapInstance) => {
    // vrstva se značkami pro odhady hrace - bez POI (setri API requesty)
    const layerWithMarks = new SMap.Layer.Marker();
    mapInstance.addLayer(layerWithMarks);
    layerWithMarks.enable();
    return layerWithMarks;
};

/**
 * Optimalizovana verze - jen marker vrstva bez POI
 */
export const setupMarkerLayerOnly = (SMap, mapInstance) => {
    const layerWithMarks = new SMap.Layer.Marker();
    mapInstance.addLayer(layerWithMarks);
    layerWithMarks.enable();
    return layerWithMarks;
};

/**
 * Vycisti cache pri ukonceni hry
 * Pozn: Mapy se ted nevyuzivaji z cache, ale funkce zustava pro zpetnou kompatibilitu
 */
export const clearMapCache = () => {
    // No-op - map instances jsou nyni spravovany jednotlivymi komponentami
};
